/**
 * @typedef {ReturnType<typeof import('widgets/forms/InputText').default>} InputText
 */
/**
 * @description Base InputBirthdayDate implementation
 * @param {InputText} InputText Base widget for extending
 * @returns {typeof InputBirthdayDate} Input Birthday Date class
 */
export default function (InputText) {
    class InputBirthdayDate extends InputText {
        init() {
            super.init();

            this.setLabel();
        }

        /**
         * @description Validate input value
         * @returns {boolean} is input valid or not
         */
        isValid() {
            var field = this.ref('field');
            var validation = this.prefs().validationConfig;
            var value = this.getValue();
            var reg = new RegExp(field.attr('pattern') || '', 'g');

            if (!value) {
                return true;
            }

            // check regExp
            if (!value.match(reg)) {
                this.error = validation.errors.parse;
                return false;
            }

            // check min value
            var inputDate = new Date(value.replace(/-/g, '/'));

            if (!(inputDate instanceof Date) || Number.isNaN(inputDate)) {
                this.error = validation.errors.parse;
                return false;
            }

            var day = inputDate.getDay();

            // restrict days of week
            var restrictedDays = field.data('restrictedDays') || [];

            if (restrictedDays.includes(day)) {
                this.error = validation.errors.restricted;
                return false;
            }

            var min = field.attr('min') ? new Date(field.attr('min').replace(/-/g, '/')) : null;
            var max = field.attr('max') ? new Date(field.attr('max').replace(/-/g, '/')) : null;

            // eslint-disable-next-line no-restricted-globals
            if (min instanceof Date && !Number.isNaN(min) && min > inputDate) {
                this.error = validation.errors.parse;
                return false;
            }
            if (max instanceof Date && !Number.isNaN(max) && max < inputDate) {
                this.error = validation.errors.parse;
                return false;
            }
            return true;
        }

        onInput(...args) {
            super.onInput(...args);

            this.setLabel();
        }

        setValue(...args) {
            super.setValue(...args);

            this.setLabel();
        }

        setLabel() {
            this.has('label', el => {
                el.attr('aria-label', this.ref('field').val());
            });
        }
    }

    return InputBirthdayDate;
}
